import { clearOtherAdvancedStyles } from "@blocks/utils";
import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { __ } from "@wordpress/i18n";
import React, { useEffect, useMemo } from "react";
import AdvancedControls from "../../../components/common/AdvancedControls";
import InspectorTabs, {
	AdvancedInspectorControls,
	GeneralInspectorControls,
	StyleInspectorControls,
} from "../../../components/common/InspectorTabs";
import LayoutOptionsRenderer from "../../../components/common/LayoutOptionsRenderer";
import Panel from "../../../components/common/Panel";
import ResponsiveControls from "../../../components/common/ResponsiveControls";
import ZStack from "../../../components/common/ZStack";
import {
	FeaturedPostLayout1Style1,
	FeaturedPostLayout2Style1,
	FeaturedPostLayout3Style1,
	FeaturedPostLayout4Style1,
	FeaturedPostLayout5Style1,
	FeaturedPostLayout6Style1,
	HeadingLayout1Style1,
	HeadingLayout2Style1,
	HeadingLayout3Style1,
	HeadingLayout4Style1,
	HeadingLayout5Style1,
	HeadingLayout6Style1,
	HeadingLayout7Style1,
	HeadingLayout8Style1,
	HeadingLayout9Style1,
	LayoutAlignBottom,
	LayoutAlignLeft,
	LayoutAlignMiddle,
	LayoutAlignRight,
	LayoutAlignTop,
} from "../../../components/icons/Icons";
import {
	Background,
	Border,
	BoxShadow,
	ColorPicker,
	Dimensions,
	IconPicker,
	Input,
	PopoverDrawer,
	Select,
	Slider,
	Toggle,
	ToggleButton,
	ToggleButtonGroup,
	Typography,
	UrlInput,
} from "../../../controls";
import Reset from "../../../controls/common/Reset";
type Props = {
	attributes: any;
	setAttributes: (attributes: any) => void;
	categories?: any[];
	tags?: any[];
	authorOptions?: any[];
	postTypeOptions?: any[];
};

const InspectorControls: React.ComponentType<Props> = (props) => {
	const {
		attributes: {
			layout,
			layout1AdvancedStyle,
			layout2AdvancedStyle,
			layout3AdvancedStyle,
			layout4AdvancedStyle,
			layout5AdvancedStyle,
			layout6AdvancedStyle,
			label,
			column,

			category,
			tag,
			orderBy,
			orderType,
			authorName,
			excludedCategory,
			postCount,
			offset,
			postType,
			lineAccent,
			lineColor,

			postBoxStyle,
			postBoxPadding,
			postBoxBackground,
			postBoxBorderColor,
			postBoxedBoxShadow,
			postBoxedBoxShadowHover,

			highlightedPostFeaturedImageHeight,
			highlightedPostBoxPadding,
			highlightedPostBoxOverlay,
			featuredImageHeight,
			featuredImageWidth,
			featuredImageBorderRadius,

			enableHeading,
			headingLayout,
			headingLayout1AdvancedStyle,
			headingLayout2AdvancedStyle,
			headingLayout3AdvancedStyle,
			headingLayout4AdvancedStyle,
			headingLayout5AdvancedStyle,
			headingLayout6AdvancedStyle,
			headingLayout7AdvancedStyle,
			headingLayout8AdvancedStyle,
			headingLayout9AdvancedStyle,
			headingColor,
			headingHoverColor,

			headingBorder,
			headingBorderBefore,
			headingBorderBottomInset,
			headingPadding,

			headingBackground,
			headingTypography,
			dotColor,

			highlightedPostTitleTypography,
			highlightTitleColor,
			highlightTitleHoverColor,
			highlightMetaIconColor,
			highlightMetaLinkColor,
			highlightMetaLinkHoverColor,
			highlightMetaSeparatorColor,
			highlightMetaTypography,

			enableFeaturedImage,
			hoverAnimation,

			postTitleTypography,
			postTitleMarkup,
			postTitleColor,
			postTitleHoverColor,
			postTitlePadding,
			postTitleMargin,

			enableCategory,
			enableHighlightedCategory,
			enableComment,
			enableHighlightedComment,
			categoryPosition,
			highlightedCategoryPosition,
			categoryColor,
			categoryBackground,
			categoryHoverColor,
			categoryHoverBackground,
			categoryPadding,
			categoryMargin,
			enableCategoryBorder,
			categoryBorder,
			categoryBoxShadow,
			categoryHoverBorder,
			categoryBoxShadowHover,
			categoryTypography,
			highlightedCategoryColor,
			highlightedCategoryBackground,
			highlightedCategoryHoverColor,
			highlightedCategoryHoverBackground,
			highlightedCategoryPadding,
			highlightedCategoryMargin,
			enableHighlightedCategoryBorder,
			highlightedCategoryBorder,
			highlightedCategoryBoxShadow,
			highlightedCategoryHoverBorder,
			highlightedCategoryBoxShadowHover,
			highlightedCategoryTypography,

			metaPosition,
			enableAuthor,
			enableDate,
			enableReadTime,
			enableViewCount,
			enableIcon,
			metaIconColor,
			metaLinkColor,
			metaLinkHoverColor,
			metaTypography,
			metaSeparatorColor,

			enableMetaSeparator,
			separatorType,

			enableExcerpt,
			excerptColor,
			excerptLimit,
			excerptMargin,
			excerptTypography,

			enableReadMore,
			readMoreText,
			enableReadMoreIcon,
			readMoreIcon,
			readMoreColor,
			readMorewHoverColor,
			readMoreTypography,
			readMoreBackground,
			readMoreHoverBackground,
			readMoreSpacing,
			readMorePadding,
			enableReadMoreBorder,
			readMoreBorder,
			readMoreHoverBorder,
			readMoreBoxShadow,
			readMoreBoxShadowHover,
			readMoreIconSpacing,
			readMoreIconSize,

			enableViewMore,
			viewMoreText,
			viewButtonPosition,
			enableViewMoreIcon,
			viewMoreIcon,
			viewMoreColor,
			viewMoreHoverColor,
			viewMoreBackground,
			viewMoreHoverBackground,
			viewMoreSpacing,
			viewMorePadding,
			enableViewMoreBorder,
			viewMoreBorder,
			viewMoreHoverBorder,
			viewMoreBoxShadow,
			viewMoreBoxShadowHover,
			viewMoreLink,
			iconSize,
			viewAllTypography,

			enablePagination,
			paginationAlignment,
			paginationColor,
			paginationBackground,
			paginationHoverColor,
			paginationHoverBackground,
			paginationPadding,
			paginationBorder,
			paginationBoxShadow,
			paginationHoverBorder,
			paginationBoxShadowHover,

			postCardBackground,
			postCardHoverBackground,
			postCardPadding,
			postCardBorder,
			postCardBoxShadow,
			postCardHoverBorder,
			postCardBoxShadowHover,

			layout4TopRowCount,
			layout4BottomRowCount,

			blockPadding,
			blockMargin,
			hideOnDesktop,
			hideOnTablet,
			hideOnMobile,
		},
		setAttributes,
		categories,
		tags,
		authorOptions,
		postTypeOptions,
	} = props;

	useEffect(() => {
		const type = wp.data.select("core/editor").getCurrentPost().type;

		if (type === "mzb-builder-template") {
			setAttributes({ postType: "mzb-builder" });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const featuredLayoutsData = useMemo(
		() => [
			{
				id: "layout-1",
				title: __("Layout 1", "magazine-blocks"),
				attrKey: "layout1AdvancedStyle",
				value: layout1AdvancedStyle,
				options: [
					{
						label: __("Style 1", "magazine-blocks"),
						value: "layout-1-style-1",
						icon: FeaturedPostLayout1Style1,
					},
				],
			},
			{
				id: "layout-2",
				title: __("Layout 2", "magazine-blocks"),
				attrKey: "layout2AdvancedStyle",
				value: layout2AdvancedStyle,
				options: [
					{
						label: __("Style 1", "magazine-blocks"),
						value: "layout-2-style-1",
						icon: FeaturedPostLayout2Style1,
					},
				],
			},
			{
				id: "layout-3",
				title: __("Layout 3", "magazine-blocks"),
				attrKey: "layout3AdvancedStyle",
				value: layout3AdvancedStyle,
				options: [
					{
						label: __("Style 1", "magazine-blocks"),
						value: "layout-3-style-1",
						icon: FeaturedPostLayout3Style1,
					},
				],
			},
			{
				id: "layout-4",
				title: __("Layout 4", "magazine-blocks"),
				attrKey: "layout4AdvancedStyle",
				value: layout4AdvancedStyle,
				options: [
					{
						label: __("Style 1", "magazine-blocks"),
						value: "layout-4-style-1",
						icon: FeaturedPostLayout4Style1,
					},
				],
			},
			{
				id: "layout-5",
				title: __("Layout 5", "magazine-blocks"),
				attrKey: "layout5AdvancedStyle",
				value: layout5AdvancedStyle,
				options: [
					{
						label: __("Style 1", "magazine-blocks"),
						value: "layout-5-style-1",
						icon: FeaturedPostLayout5Style1,
					},
				],
			},
			{
				id: "layout-6",
				title: __("Layout 6", "magazine-blocks"),
				attrKey: "layout6AdvancedStyle",
				value: layout6AdvancedStyle,
				options: [
					{
						label: __("Style 1", "magazine-blocks"),
						value: "layout-6-style-1",
						icon: FeaturedPostLayout6Style1,
					},
				],
			},
		],
		[
			layout1AdvancedStyle,
			layout2AdvancedStyle,
			layout3AdvancedStyle,
			layout4AdvancedStyle,
			layout5AdvancedStyle,
			layout6AdvancedStyle,
		]
	);

	const headingLayoutsData = useMemo(
		() => [
			{
				id: "heading-layout-1",
				title: __("Layout 1", "magazine-blocks"),
				attrKey: "headingLayout1AdvancedStyle",
				value: headingLayout1AdvancedStyle,
				options: [
					{
						label: __("Style 1", "magazine-blocks"),
						value: "heading-layout-1-style-1",
						icon: HeadingLayout1Style1,
					},
				],
			},
			{
				id: "heading-layout-2",
				title: __("Layout 2", "magazine-blocks"),
				attrKey: "headingLayout2AdvancedStyle",
				value: headingLayout2AdvancedStyle,
				options: [
					{
						label: __("Style 1", "magazine-blocks"),
						value: "heading-layout-2-style-1",
						icon: HeadingLayout2Style1,
					},
				],
			},
			{
				id: "heading-layout-3",
				title: __("Layout 3", "magazine-blocks"),
				attrKey: "headingLayout3AdvancedStyle",
				value: headingLayout3AdvancedStyle,
				options: [
					{
						label: __("Style 1", "magazine-blocks"),
						value: "heading-layout-3-style-1",
						icon: HeadingLayout3Style1,
					},
				],
			},
			{
				id: "heading-layout-4",
				title: __("Layout 4", "magazine-blocks"),
				attrKey: "headingLayout4AdvancedStyle",
				value: headingLayout4AdvancedStyle,
				options: [
					{
						label: __("Style 1", "magazine-blocks"),
						value: "heading-layout-4-style-1",
						icon: HeadingLayout4Style1,
					},
				],
			},
			{
				id: "heading-layout-5",
				title: __("Layout 5", "magazine-blocks"),
				attrKey: "headingLayout5AdvancedStyle",
				value: headingLayout5AdvancedStyle,
				options: [
					{
						label: __("Style 1", "magazine-blocks"),
						value: "heading-layout-5-style-1",
						icon: HeadingLayout5Style1,
					},
				],
			},
			{
				id: "heading-layout-6",
				title: __("Layout 6", "magazine-blocks"),
				attrKey: "headingLayout6AdvancedStyle",
				value: headingLayout6AdvancedStyle,
				options: [
					{
						label: __("Style 1", "magazine-blocks"),
						value: "heading-layout-6-style-1",
						icon: HeadingLayout6Style1,
					},
				],
			},
			{
				id: "heading-layout-7",
				title: __("Layout 7", "magazine-blocks"),
				attrKey: "headingLayout7AdvancedStyle",
				value: headingLayout7AdvancedStyle,
				options: [
					{
						label: __("Style 1", "magazine-blocks"),
						value: "heading-layout-7-style-1",
						icon: HeadingLayout7Style1,
					},
				],
			},
			{
				id: "heading-layout-8",
				title: __("Layout 8", "magazine-blocks"),
				attrKey: "headingLayout8AdvancedStyle",
				value: headingLayout8AdvancedStyle,
				options: [
					{
						label: __("Style 1", "magazine-blocks"),
						value: "heading-layout-8-style-1",
						icon: HeadingLayout8Style1,
					},
				],
			},
			{
				id: "heading-layout-9",
				title: __("Layout 9", "magazine-blocks"),
				attrKey: "headingLayout9AdvancedStyle",
				value: headingLayout9AdvancedStyle,
				options: [
					{
						label: __("Style 1", "magazine-blocks"),
						value: "heading-layout-9-style-1",
						icon: HeadingLayout9Style1,
					},
				],
			},
		],
		[
			headingLayout1AdvancedStyle,
			headingLayout2AdvancedStyle,
			headingLayout3AdvancedStyle,
			headingLayout4AdvancedStyle,
			headingLayout5AdvancedStyle,
			headingLayout6AdvancedStyle,
			headingLayout7AdvancedStyle,
			headingLayout8AdvancedStyle,
			headingLayout9AdvancedStyle,
		]
	);

	return (
		<>
			<InspectorTabs />
			<GeneralInspectorControls>
				<Panel title={__("Layout", "magazine-blocks")} initialOpen>
					<LayoutOptionsRenderer
						layoutsData={featuredLayoutsData}
						selectedValues={Object.fromEntries(
							featuredLayoutsData.map((ld) => [
								ld.attrKey,
								ld.value,
							])
						)}
						onChange={(attrKey, value, layoutId) =>
							setAttributes({
								...clearOtherAdvancedStyles(
									featuredLayoutsData,
									attrKey
								),
								[attrKey]: value,
								layout: layoutId,
							})
						}
						currentLayout={layout}
					/>
					{"layout-1" === layout && (
						<Select
							value={column}
							onChange={(val) =>
								setAttributes({ column: parseInt(val) })
							}
							label={__("Column", "magazine-blocks")}
							options={[
								{
									label: __("1", "magazine-blocks"),
									value: "1",
								},
								{
									label: __("2", "magazine-blocks"),
									value: "2",
								},
								{
									label: __("3", "magazine-blocks"),
									value: "3",
								},
							]}
						/>
					)}
					{"layout-4" === layout && (
						<Slider
							label={__("Top Row Post Count", "magazine-blocks")}
							value={layout4TopRowCount}
							step={1}
							min={1}
							max={3}
							onChange={(val) =>
								setAttributes({ layout4TopRowCount: val })
							}
						/>
					)}
					{"layout-4" === layout && (
						<Slider
							label={__(
								"Bottom Row Post Count",
								"magazine-blocks"
							)}
							value={layout4BottomRowCount}
							step={1}
							min={1}
							max={4}
							onChange={(val) =>
								setAttributes({ layout4BottomRowCount: val })
							}
						/>
					)}
				</Panel>
				<Panel title={__("Post Options", "magazine-blocks")}>
					<Select
						options={postTypeOptions ?? []}
						onChange={(val) => setAttributes({ postType: val })}
						value={postType}
						label={__("Post Type", "magazine-blocks")}
					/>
					<Slider
						label={__("Post Count", "magazine-blocks")}
						value={postCount}
						step={1}
						min={1}
						max={15}
						onChange={(val) => setAttributes({ postCount: val })}
						resetAttributeKey="postCount"
					/>
					<Slider
						label={__("Offset", "magazine-blocks")}
						value={offset}
						step={1}
						min={0}
						max={15}
						onChange={(val) => setAttributes({ offset: val })}
						resetAttributeKey="offset"
					/>
					<Select
						options={[
							{
								label: __("Date", "magazine-blocks"),
								value: "date",
							},
							{
								label: __("Title", "magazine-blocks"),
								value: "title",
							},
							{
								label: __("Random", "magazine-blocks"),
								value: "rand",
							},
						]}
						onChange={(val) => setAttributes({ orderBy: val })}
						value={orderBy}
						label={__("Order By", "magazine-blocks")}
					/>

					<>
						<ToggleButtonGroup
							value={orderType}
							onChange={(v) => {
								setAttributes({ orderType: v });
							}}
							label={__("Order", "magazine-blocks")}
							groupProps={{
								sx: {
									".chakra-button": {
										minH: "32px",
										color: "#1A202C",
										svg: {
											w: 6,
											h: 6,
										},
										"&[data-active]": {
											color: "#fff !important",
										},
									},
								},
							}}
						>
							<ToggleButton value="asc">Ascending</ToggleButton>
							<ToggleButton value="desc">Descending</ToggleButton>
						</ToggleButtonGroup>
					</>
					{postType !== "mzb-builder" && (
						<>
							<Select
								value={category}
								onChange={(val) =>
									setAttributes({ category: val })
								}
								label={__("Category", "magazine-blocks")}
								options={[
									{ value: "all", label: __("All") },
									...(categories ?? [])?.map(
										({ name, id }) => ({
											label: name,
											value: id.toString(),
										})
									),
								]}
							/>

							<Select
								isMulti
								value={excludedCategory}
								onChange={(val) =>
									setAttributes({ excludedCategory: val })
								}
								label={__(
									"Excluded Category",
									"magazine-blocks"
								)}
								options={[
									...(categories ?? [])?.map(
										({ name, id }) => ({
											label: name,
											value: id.toString(),
										})
									),
								]}
							/>
							<Select
								value={tag}
								onChange={(val) => setAttributes({ tag: val })}
								label={__("Tag", "magazine-blocks")}
								options={[
									{ value: "all", label: __("All") },
									...(tags ?? [])?.map(({ name, id }) => ({
										label: name,
										value: id.toString(),
									})),
								]}
							/>
							<Select
								options={[
									{
										value: "all",
										label: __("All", "magazine-blocks"),
									},
									...(authorOptions ?? []),
								]}
								onChange={(val) =>
									setAttributes({ authorName: val })
								}
								value={authorName}
								label={__("Authors", "magazine-blocks")}
							/>
						</>
					)}
				</Panel>
				<Panel title={__("Heading", "magazine-blocks")}>
					<Toggle
						checked={enableHeading}
						onChange={() =>
							setAttributes({ enableHeading: !enableHeading })
						}
						label={__("Enable", "magazine-blocks")}
					/>
					{enableHeading && (
						<>
							<Input
								onChange={(val) =>
									setAttributes({ label: val })
								}
								label={__("Label", "magazine-blocks")}
								value={label || ""}
							/>
							<LayoutOptionsRenderer
								columns={2}
								layoutsData={headingLayoutsData}
								selectedValues={Object.fromEntries(
									headingLayoutsData.map((ld) => [
										ld.attrKey,
										ld.value,
									])
								)}
								onChange={(attrKey, value, layoutId) =>
									setAttributes({
										...clearOtherAdvancedStyles(
											headingLayoutsData,
											attrKey
										),
										[attrKey]: value,
										headingLayout: layoutId,
									})
								}
								currentLayout={headingLayout}
							/>
						</>
					)}
				</Panel>
				<Panel title={__("Post Box", "magazine-blocks")}>
					<Select
						options={[
							{
								label: __("None", "magazine-blocks"),
								value: "none",
							},
							{
								label: __("Boxed", "magazine-blocks"),
								value: "boxed",
							},
							{
								label: __("Border", "magazine-blocks"),
								value: "border",
							},
						]}
						onChange={(val) => setAttributes({ postBoxStyle: val })}
						value={postBoxStyle}
						label={__("Style", "magazine-blocks")}
					/>
				</Panel>
				<Panel title={__("Image", "magazine-blocks")}>
					<Toggle
						checked={enableFeaturedImage}
						onChange={() =>
							setAttributes({
								enableFeaturedImage: !enableFeaturedImage,
							})
						}
						label={__("Enable", "magazine-blocks")}
					/>
					{enableFeaturedImage && (
						<Select
							options={[
								{
									label: __("None", "magazine-blocks"),
									value: "none",
								},
								{
									label: __("Zoom In", "magazine-blocks"),
									value: "zoomIn",
								},
								{
									label: __("Zoom Out", "magazine-blocks"),
									value: "zoomOut",
								},
								{
									label: __("Opacity", "magazine-blocks"),
									value: "opacity",
								},
								{
									label: __("Rotate Left", "magazine-blocks"),
									value: "rotateLeft",
								},
								{
									label: __(
										"Rotate Right",
										"magazine-blocks"
									),
									value: "rotateRight",
								},
								{
									label: __("Slide Left", "magazine-blocks"),
									value: "slideLeft",
								},
								{
									label: __("Slide Right", "magazine-blocks"),
									value: "slideRight",
								},
							]}
							onChange={(val) =>
								setAttributes({ hoverAnimation: val })
							}
							value={hoverAnimation}
							label={__("Hover Animation", "magazine-blocks")}
						/>
					)}
				</Panel>
				<Panel title={__("Post Title", "magazine-blocks")}>
					<Select
						options={[
							{
								label: __("H1", "magazine-blocks"),
								value: "h1",
							},
							{
								label: __("H2", "magazine-blocks"),
								value: "h2",
							},
							{
								label: __("H3", "magazine-blocks"),
								value: "h3",
							},
							{
								label: __("H4", "magazine-blocks"),
								value: "h4",
							},
							{
								label: __("H5", "magazine-blocks"),
								value: "h5",
							},
							{
								label: __("H6", "magazine-blocks"),
								value: "h6",
							},
						]}
						onChange={(val) =>
							setAttributes({ postTitleMarkup: val })
						}
						value={postTitleMarkup}
						label={__("HTML Markup", "magazine-blocks")}
					/>
				</Panel>
				<Panel title={__("Header Meta", "magazine-blocks")}>
					<Tabs isFitted variant="unstyled">
						<TabList
							border="1px solid #E0E0E0"
							p="4px"
							borderRadius="2px"
						>
							{layout !== "layout-2" && (
								<Tab
									_selected={{
										color: "white",
										bg: "#7E36F4",
										borderRadius: "2px",
									}}
								>
									Post Box
								</Tab>
							)}
							<Tab
								_selected={{
									color: "white",
									bg: "#7E36F4",
									borderRadius: "2px",
								}}
							>
								Highlighted
							</Tab>
						</TabList>
						<TabPanels>
							{layout !== "layout-2" && (
								<TabPanel p="16px 0 0 0">
									<Box p="0 0 10px 0">
										<Toggle
											checked={enableCategory}
											onChange={() =>
												setAttributes({
													enableCategory:
														!enableCategory,
												})
											}
											label={__(
												"Category",
												"magazine-blocks"
											)}
										/>
									</Box>
									<Box p="0 0 10px 0">
										<Toggle
											checked={enableComment}
											onChange={() =>
												setAttributes({
													enableComment:
														!enableComment,
												})
											}
											label={__(
												"Comment",
												"magazine-blocks"
											)}
										/>
									</Box>
									{(enableCategory || enableComment) && (
										<Box p="0 0 10px 0">
											<Select
												value={categoryPosition}
												onChange={(val) =>
													setAttributes({
														categoryPosition: val,
													})
												}
												label={__(
													"Position",
													"magazine-blocks"
												)}
												options={[
													{
														label: __(
															"Outside Image",
															"magazine-blocks"
														),
														value: "out-image",
													},
													{
														label: __(
															"Inside Image",
															"magazine-blocks"
														),
														value: "in-image",
													},
												]}
											/>
										</Box>
									)}
								</TabPanel>
							)}
							<TabPanel p="16px 0 0 0">
								<Box p="0 0 10px 0">
									<Toggle
										checked={enableHighlightedCategory}
										onChange={() =>
											setAttributes({
												enableHighlightedCategory:
													!enableHighlightedCategory,
											})
										}
										label={__(
											"Category",
											"magazine-blocks"
										)}
									/>
								</Box>
								<Box p="0 0 10px 0">
									<Toggle
										checked={enableHighlightedComment}
										onChange={() =>
											setAttributes({
												enableHighlightedComment:
													!enableHighlightedComment,
											})
										}
										label={__("Comment", "magazine-blocks")}
									/>
								</Box>
								{(enableHighlightedCategory ||
									enableHighlightedComment) && (
									<Box p="0 0 10px 0">
										<Select
											value={highlightedCategoryPosition}
											onChange={(val) =>
												setAttributes({
													highlightedCategoryPosition:
														val,
												})
											}
											label={__(
												"Position",
												"magazine-blocks"
											)}
											options={[
												{
													label: __(
														"Outside Image",
														"magazine-blocks"
													),
													value: "out-image",
												},
												{
													label: __(
														"Inside Image",
														"magazine-blocks"
													),
													value: "in-image",
												},
											]}
										/>
									</Box>
								)}
							</TabPanel>
						</TabPanels>
					</Tabs>
				</Panel>
				<Panel title={__("Meta", "magazine-blocks")}>
					{(enableDate ||
						enableAuthor ||
						enableReadTime ||
						enableViewCount) && (
						<ToggleButtonGroup
							value={metaPosition}
							onChange={(v) => {
								setAttributes({ metaPosition: v });
							}}
							label={__("Position", "magazine-blocks")}
							groupProps={{
								sx: {
									".chakra-button": {
										minH: "32px",
										svg: {
											w: 6,
											h: 6,
										},
									},
								},
							}}
						>
							<ToggleButton value="top">
								<LayoutAlignTop />
							</ToggleButton>
							<ToggleButton value="bottom">
								<LayoutAlignBottom />
							</ToggleButton>
						</ToggleButtonGroup>
					)}
					<Toggle
						checked={enableAuthor}
						onChange={() =>
							setAttributes({ enableAuthor: !enableAuthor })
						}
						label={__("Author", "magazine-blocks")}
					/>
					<Toggle
						checked={enableDate}
						onChange={() =>
							setAttributes({ enableDate: !enableDate })
						}
						label={__("Date", "magazine-blocks")}
					/>
					<Toggle
						checked={enableReadTime}
						onChange={() =>
							setAttributes({ enableReadTime: !enableReadTime })
						}
						label={__("Read Time", "magazine-blocks")}
					/>
					<Toggle
						checked={enableViewCount}
						onChange={() =>
							setAttributes({ enableViewCount: !enableViewCount })
						}
						label={__("View Count", "magazine-blocks")}
					/>
					<Toggle
						checked={enableMetaSeparator}
						onChange={() =>
							setAttributes({
								enableMetaSeparator: !enableMetaSeparator,
							})
						}
						label={__("Separator", "magazine-blocks")}
					/>
					{enableMetaSeparator && (
						<Select
							options={[
								{
									label: __("None", "magazine-blocks"),
									value: "none",
								},
								{
									label: __("Circle", "magazine-blocks"),
									value: "circle",
								},
								{
									label: __("Square", "magazine-blocks"),
									value: "square",
								},
								{
									label: __(
										"Vertical Dash",
										"magazine-blocks"
									),
									value: "vertical-dash",
								},
								{
									label: __(
										"Horizontal Dash",
										"magazine-blocks"
									),
									value: "horizontal-dash",
								},
								{
									label: __(
										"Outline Circle",
										"magazine-blocks"
									),
									value: "outline-circle",
								},
							]}
							onChange={(val) =>
								setAttributes({ separatorType: val })
							}
							value={separatorType}
							label={__("Separator Type", "magazine-blocks")}
						/>
					)}
					<Toggle
						checked={enableIcon}
						onChange={() =>
							setAttributes({ enableIcon: !enableIcon })
						}
						label={__("Icon", "magazine-blocks")}
					/>
				</Panel>
				<Panel title={__("Excerpt", "magazine-blocks")}>
					<Toggle
						checked={enableExcerpt}
						onChange={() =>
							setAttributes({ enableExcerpt: !enableExcerpt })
						}
						label={__("Enable", "magazine-blocks")}
					/>
					{enableExcerpt && (
						<Slider
							label={__("Limit", "magazine-blocks")}
							value={excerptLimit}
							step={1}
							min={1}
							max={20}
							onChange={(val) =>
								setAttributes({ excerptLimit: val })
							}
							resetAttributeKey="excerptLimit"
						/>
					)}
				</Panel>
				<Panel title={__("Read More", "magazine-blocks")}>
					<Toggle
						checked={enableReadMore}
						onChange={() =>
							setAttributes({
								enableReadMore: !enableReadMore,
							})
						}
						label={__("Enable", "magazine-blocks")}
					/>
					{enableReadMore && (
						<>
							<Input
								value={readMoreText}
								label={__("Text", "magazine-blocks")}
								onChange={(val) =>
									setAttributes({ readMoreText: val })
								}
							/>
							<Toggle
								checked={enableReadMoreIcon}
								onChange={() =>
									setAttributes({
										enableReadMoreIcon: !enableReadMoreIcon,
									})
								}
								label={__("Enable Icon", "magazine-blocks")}
							/>
							{enableReadMoreIcon && (
								<IconPicker
									value={readMoreIcon}
									onChange={(val) =>
										setAttributes({ readMoreIcon: val })
									}
								/>
							)}
						</>
					)}
				</Panel>
				<Panel title={__("View All", "magazine-blocks")}>
					<Toggle
						checked={enableViewMore}
						onChange={() =>
							setAttributes({
								enableViewMore: !enableViewMore,
							})
						}
						label={__("Enable", "magazine-blocks")}
					/>
					{enableViewMore && (
						<>
							<Input
								value={viewMoreText}
								label={__("Text", "magazine-blocks")}
								onChange={(val) =>
									setAttributes({ viewMoreText: val })
								}
							/>
							<Select
								options={[
									{
										label: __("Top", "magazine-blocks"),
										value: "top",
									},
									{
										label: __("Bottom", "magazine-blocks"),
										value: "bottom",
									},
								]}
								onChange={(val) =>
									setAttributes({ viewButtonPosition: val })
								}
								value={viewButtonPosition}
								label={__(
									"View Button Position",
									"magazine-blocks"
								)}
							/>
							<Toggle
								checked={enableViewMoreIcon}
								onChange={() =>
									setAttributes({
										enableViewMoreIcon: !enableViewMoreIcon,
									})
								}
								label={__("Enable Icon", "magazine-blocks")}
							/>
							{enableViewMoreIcon && (
								<IconPicker
									value={viewMoreIcon}
									onChange={(val) =>
										setAttributes({ viewMoreIcon: val })
									}
								/>
							)}
							<UrlInput
								onChange={(val) =>
									setAttributes({ viewMoreLink: val })
								}
								label={__("View More Link", "magazine-blocks")}
								value={viewMoreLink}
								newTab
								noFollow
							/>
						</>
					)}
				</Panel>
				<Panel title={__("Pagination", "magazine-blocks")}>
					<Toggle
						checked={enablePagination}
						onChange={() =>
							setAttributes({
								enablePagination: !enablePagination,
							})
						}
						label={__("Enable", "magazine-blocks")}
					/>
					{enablePagination && (
						<ToggleButtonGroup
							value={paginationAlignment}
							onChange={(v) => {
								setAttributes({ paginationAlignment: v });
							}}
							label={__("Alignment", "magazine-blocks")}
							responsive
							groupProps={{
								sx: {
									".chakra-button": {
										minH: "32px",
										svg: {
											w: 6,
											h: 6,
										},
									},
								},
							}}
						>
							<ToggleButton value="left">
								<LayoutAlignLeft />
							</ToggleButton>
							<ToggleButton value="center">
								<LayoutAlignMiddle />
							</ToggleButton>
							<ToggleButton value="right">
								<LayoutAlignRight />
							</ToggleButton>
						</ToggleButtonGroup>
					)}
				</Panel>
			</GeneralInspectorControls>
			<StyleInspectorControls>
				<Panel title={__("Post Box", "magazine-blocks")}>
					<Dimensions
						value={postBoxPadding}
						responsive
						label={__("Padding", "magazine-blocks")}
						type="padding"
						defaultUnit="px"
						units={["px", "rem", "em", "%"]}
						onChange={(val) =>
							setAttributes({ postBoxPadding: val })
						}
						resetAttributeKey="postBoxPadding"
					/>
					{"boxed" === postBoxStyle && (
						<PopoverDrawer
							label={__("Background", "magazine-blocks")}
						>
							<Tabs position="relative">
								<TabList>
									<Tab>{__("Normal", "magazine-blocks")}</Tab>
								</TabList>
								<TabPanels>
									<TabPanel>
										<Reset
											saved={postBoxBackground}
											resetKey="postBoxBackground"
											onReset={(v) => {
												setAttributes({
													postBoxBackground: v,
												});
											}}
											buttonProps={{
												position: "absolute",
												top: "12px",
												right: "10px",
											}}
										/>
										<Background
											value={postBoxBackground}
											onChange={(v) =>
												setAttributes({
													postBoxBackground: v,
												})
											}
										/>
									</TabPanel>
								</TabPanels>
							</Tabs>
						</PopoverDrawer>
					)}
					{"border" === postBoxStyle && (
						<PopoverDrawer
							label={__("Border Color", "magazine-blocks")}
							trigger={(props) => (
								<PopoverDrawer.Trigger {...props}>
									<ZStack
										items={[
											{
												color: postBoxBorderColor,
												id: "postBoxBorderColor",
											},
										]}
									/>
								</PopoverDrawer.Trigger>
							)}
							closeOnFocusOutside
						>
							<Tabs position="relative">
								<TabList>
									<Tab>{__("Normal", "magazine-blocks")}</Tab>
								</TabList>
								<TabPanels>
									<TabPanel>
										<Reset
											saved={postBoxBorderColor}
											resetKey="postBoxBorderColor"
											onReset={(v) => {
												setAttributes({
													postBoxBorderColor: v,
												});
											}}
											buttonProps={{
												position: "absolute",
												top: "12px",
												right: "10px",
											}}
										/>
										<ColorPicker
											value={postBoxBorderColor}
											onChange={(v) =>
												setAttributes({
													postBoxBorderColor: v,
												})
											}
										/>
									</TabPanel>
								</TabPanels>
							</Tabs>
						</PopoverDrawer>
					)}
					<Tabs isFitted variant="unstyled">
						<TabList
							border="1px solid #E0E0E0"
							p="4px"
							borderRadius="2px"
						>
							<Tab
								_selected={{
									color: "white",
									bg: "#7E36F4",
									borderRadius: "2px",
								}}
							>
								Normal
							</Tab>
							<Tab
								_selected={{
									color: "white",
									bg: "#7E36F4",
									borderRadius: "2px",
								}}
							>
								Hover
							</Tab>
						</TabList>
						<TabPanels>
							<TabPanel p="16px 0">
								<BoxShadow
									resetAttributeKey="postBoxedBoxShadow"
									value={postBoxedBoxShadow}
									onChange={(val) =>
										setAttributes({
											postBoxedBoxShadow: val,
										})
									}
								/>
							</TabPanel>
							<TabPanel p="16px 0">
								<BoxShadow
									resetAttributeKey="postBoxedBoxShadowHover"
									value={postBoxedBoxShadowHover}
									onChange={(val) =>
										setAttributes({
											postBoxedBoxShadowHover: val,
										})
									}
								/>
							</TabPanel>
						</TabPanels>
					</Tabs>
				</Panel>
				<Panel title={__("Highlighted Post", "magazine-blocks")}>
					<PopoverDrawer
						label={__("Text Color", "magazine-blocks")}
						trigger={(props) => (
							<PopoverDrawer.Trigger {...props}>
								<ZStack
									items={[
										{
											color: highlightTitleColor,
											id: "highlightTitleColor",
										},
										{
											color: highlightTitleHoverColor,
											id: "highlightTitleHoverColor",
										},
									]}
								/>
							</PopoverDrawer.Trigger>
						)}
						closeOnFocusOutside
					>
						<Tabs position="relative">
							<TabList>
								<Tab>{__("Normal", "magazine-blocks")}</Tab>
								<Tab>{__("Hover", "magazine-blocks")}</Tab>
							</TabList>
							<TabPanels>
								<TabPanel>
									<Reset
										saved={highlightTitleColor}
										resetKey="highlightTitleColor"
										onReset={(v) => {
											setAttributes({
												highlightTitleColor: v,
											});
										}}
										buttonProps={{
											position: "absolute",
											top: "12px",
											right: "10px",
										}}
									/>
									<ColorPicker
										value={highlightTitleColor}
										onChange={(v) =>
											setAttributes({
												highlightTitleColor: v,
											})
										}
									/>
								</TabPanel>
								<TabPanel>
									<Reset
										saved={highlightTitleHoverColor}
										resetKey="highlightTitleHoverColor"
										onReset={(v) => {
											setAttributes({
												highlightTitleHoverColor: v,
											});
										}}
										buttonProps={{
											position: "absolute",
											top: "12px",
											right: "10px",
										}}
									/>
									<ColorPicker
										value={highlightTitleHoverColor}
										onChange={(v) =>
											setAttributes({
												highlightTitleHoverColor: v,
											})
										}
									/>
								</TabPanel>
							</TabPanels>
						</Tabs>
					</PopoverDrawer>
					<Typography
						value={highlightedPostTitleTypography}
						onChange={(val) =>
							setAttributes({
								highlightedPostTitleTypography: val,
							})
						}
						resetAttributeKey="highlightedPostTitleTypography"
					/>
					{"layout-5" === layout && (
						<PopoverDrawer label={__("Overlay", "magazine-blocks")}>
							<Tabs position="relative">
								<TabList>
									<Tab>{__("Normal", "magazine-blocks")}</Tab>
								</TabList>
								<TabPanels>
									<TabPanel>
										<Reset
											saved={highlightedPostBoxOverlay}
											resetKey="highlightedPostBoxOverlay"
											onReset={(v) => {
												setAttributes({
													highlightedPostBoxOverlay:
														v,
												});
											}}
											buttonProps={{
												position: "absolute",
												top: "12px",
												right: "10px",
											}}
										/>
										<Background
											value={highlightedPostBoxOverlay}
											onChange={(v) =>
												setAttributes({
													highlightedPostBoxOverlay:
														v,
												})
											}
										/>
									</TabPanel>
								</TabPanels>
							</Tabs>
						</PopoverDrawer>
					)}
					<Slider
						onChange={(val: any) =>
							setAttributes({
								highlightedPostFeaturedImageHeight: val,
							})
						}
						label={__("Image Height", "magazine-blocks")}
						units={["px", "em", "%"]}
						responsive={true}
						min={160}
						max={1000}
						value={highlightedPostFeaturedImageHeight}
						resetAttributeKey="highlightedPostFeaturedImageHeight"
					/>
					<Dimensions
						value={highlightedPostBoxPadding}
						responsive
						label={__("Padding", "magazine-blocks")}
						type="padding"
						defaultUnit="px"
						units={["px", "rem", "em", "%"]}
						onChange={(val) =>
							setAttributes({ highlightedPostBoxPadding: val })
						}
						resetAttributeKey="highlightedPostBoxPadding"
					/>
				</Panel>
				<Panel title={__("Image", "magazine-blocks")}>
					{enableFeaturedImage && (
						<Slider
							onChange={(val: any) =>
								setAttributes({ featuredImageWidth: val })
							}
							label={__("Width", "magazine-blocks")}
							units={["px", "em", "%"]}
							responsive={true}
							min={70}
							max={1000}
							value={featuredImageWidth}
							resetAttributeKey="featuredImageWidth"
						/>
					)}
					{enableFeaturedImage && (
						<Slider
							onChange={(val: any) =>
								setAttributes({ featuredImageHeight: val })
							}
							label={__("Height", "magazine-blocks")}
							units={["px", "em", "%"]}
							responsive={true}
							min={70}
							max={1000}
							value={featuredImageHeight}
							resetAttributeKey="featuredImageHeight"
						/>
					)}
					{enableFeaturedImage && (
						<Dimensions
							value={featuredImageBorderRadius || {}}
							responsive
							label={__("Radius", "magazine-blocks")}
							min={0}
							max={500}
							defaultUnit="px"
							units={["px", "rem", "em", "%"]}
							onChange={(val) =>
								setAttributes({
									featuredImageBorderRadius: val,
								})
							}
							resetAttributeKey="featuredImageBorderRadius"
						/>
					)}
				</Panel>
				{enableHeading && (
					<Panel title={__("Heading", "magazine-blocks")}>
						<PopoverDrawer
							label={__("Heading Color", "magazine-blocks")}
							trigger={(props) => (
								<PopoverDrawer.Trigger {...props}>
									<ZStack
										items={[
											{
												color: headingColor,
												id: "headingColor",
											},
											{
												color: headingHoverColor,
												id: "headingHoverColor",
											},
										]}
									/>
								</PopoverDrawer.Trigger>
							)}
							closeOnFocusOutside
						>
							<Tabs position="relative">
								<TabList>
									<Tab>{__("Normal", "magazine-blocks")}</Tab>
									<Tab>{__("Hover", "magazine-blocks")}</Tab>
								</TabList>
								<TabPanels>
									<TabPanel>
										<Reset
											saved={headingColor}
											resetKey="headingColor"
											onReset={(v) => {
												setAttributes({
													headingColor: v,
												});
											}}
											buttonProps={{
												position: "absolute",
												top: "12px",
												right: "10px",
											}}
										/>
										<ColorPicker
											value={headingColor}
											onChange={(v) =>
												setAttributes({
													headingColor: v,
												})
											}
										/>
									</TabPanel>
									<TabPanel>
										<Reset
											saved={headingHoverColor}
											resetKey="headingHoverColor"
											onReset={(v) => {
												setAttributes({
													headingHoverColor: v,
												});
											}}
											buttonProps={{
												position: "absolute",
												top: "12px",
												right: "10px",
											}}
										/>
										<ColorPicker
											value={headingHoverColor}
											onChange={(v) =>
												setAttributes({
													headingHoverColor: v,
												})
											}
										/>
									</TabPanel>
								</TabPanels>
							</Tabs>
						</PopoverDrawer>
						{("heading-layout-6" === headingLayout ||
							"heading-layout-7" === headingLayout) && (
							<>
								<Dimensions
									value={headingPadding}
									responsive
									label={__("Padding", "magazine-blocks")}
									type="padding"
									defaultUnit="px"
									units={["px", "rem", "em", "%"]}
									onChange={(val) =>
										setAttributes({
											headingPadding: val,
										})
									}
									resetAttributeKey="headingPadding"
								/>
							</>
						)}
						<Typography
							value={headingTypography}
							onChange={(val) =>
								setAttributes({ headingTypography: val })
							}
							resetAttributeKey="headingTypography"
						/>

						{"heading-layout-2" === headingLayout && (
							<PopoverDrawer
								label={__("Background", "magazine-blocks")}
							>
								<Tabs position="relative">
									<TabList>
										<Tab>
											{__("Normal", "magazine-blocks")}
										</Tab>
									</TabList>
									<TabPanels>
										<TabPanel>
											<Reset
												saved={headingBackground}
												resetKey="headingBackground"
												onReset={(v) => {
													setAttributes({
														headingBackground: v,
													});
												}}
												buttonProps={{
													position: "absolute",
													top: "12px",
													right: "10px",
												}}
											/>
											<Background
												value={headingBackground}
												onChange={(v) =>
													setAttributes({
														headingBackground: v,
													})
												}
											/>
										</TabPanel>
									</TabPanels>
								</Tabs>
							</PopoverDrawer>
						)}

						{("heading-layout-1" === headingLayout ||
							"heading-layout-3" === headingLayout ||
							"heading-layout-7" === headingLayout ||
							"heading-layout-8" === headingLayout) && (
							<>
								<PopoverDrawer
									label={__("Line Accent", "magazine-blocks")}
									trigger={(props) => (
										<PopoverDrawer.Trigger {...props}>
											<ZStack
												items={[
													{
														color: lineAccent,
														id: "lineAccent",
													},
												]}
											/>
										</PopoverDrawer.Trigger>
									)}
									closeOnFocusOutside
								>
									<Tabs position="relative">
										<TabList>
											<Tab>
												{__(
													"Normal",
													"magazine-blocks"
												)}
											</Tab>
										</TabList>
										<TabPanels>
											<TabPanel>
												<Reset
													saved={lineAccent}
													resetKey="lineAccent"
													onReset={(v) => {
														setAttributes({
															lineAccent: v,
														});
													}}
													buttonProps={{
														position: "absolute",
														top: "12px",
														right: "10px",
													}}
												/>
												<ColorPicker
													value={lineAccent}
													onChange={(v) =>
														setAttributes({
															lineAccent: v,
														})
													}
												/>
											</TabPanel>
										</TabPanels>
									</Tabs>
								</PopoverDrawer>
							</>
						)}

						{("heading-layout-2" === headingLayout ||
							"heading-layout-3" === headingLayout ||
							"heading-layout-4" === headingLayout ||
							"heading-layout-5" === headingLayout ||
							"heading-layout-5" === headingLayout ||
							"heading-layout-6" === headingLayout ||
							"heading-layout-7" === headingLayout ||
							"heading-layout-9" === headingLayout) && (
							<>
								<PopoverDrawer
									label={__("Line Color", "magazine-blocks")}
									trigger={(props) => (
										<PopoverDrawer.Trigger {...props}>
											<ZStack
												items={[
													{
														color: lineColor,
														id: "lineColor",
													},
												]}
											/>
										</PopoverDrawer.Trigger>
									)}
									closeOnFocusOutside
								>
									<Tabs position="relative">
										<TabList>
											<Tab>
												{__(
													"Normal",
													"magazine-blocks"
												)}
											</Tab>
										</TabList>
										<TabPanels>
											<TabPanel>
												<Reset
													saved={lineColor}
													resetKey="lineColor"
													onReset={(v) => {
														setAttributes({
															lineColor: v,
														});
													}}
													buttonProps={{
														position: "absolute",
														top: "12px",
														right: "10px",
													}}
												/>
												<ColorPicker
													value={lineColor}
													onChange={(v) =>
														setAttributes({
															lineColor: v,
														})
													}
												/>
											</TabPanel>
										</TabPanels>
									</Tabs>
								</PopoverDrawer>
							</>
						)}

						{("heading-layout-4" === headingLayout ||
							"heading-layout-5" === headingLayout) && (
							<PopoverDrawer
								label={__("Dot Color", "magazine-blocks")}
								trigger={(props) => (
									<PopoverDrawer.Trigger {...props}>
										<ZStack
											items={[
												{
													color: dotColor,
													id: "dotColor",
												},
											]}
										/>
									</PopoverDrawer.Trigger>
								)}
								closeOnFocusOutside
							>
								<Tabs position="relative">
									<TabList>
										<Tab>
											{__("Normal", "magazine-blocks")}
										</Tab>
									</TabList>
									<TabPanels>
										<TabPanel>
											<Reset
												saved={dotColor}
												resetKey="dotColor"
												onReset={(v) => {
													setAttributes({
														dotColor: v,
													});
												}}
												buttonProps={{
													position: "absolute",
													top: "12px",
													right: "10px",
												}}
											/>
											<ColorPicker
												value={dotColor}
												onChange={(v) =>
													setAttributes({
														dotColor: v,
													})
												}
											/>
										</TabPanel>
									</TabPanels>
								</Tabs>
							</PopoverDrawer>
						)}
					</Panel>
				)}
				<Panel title={__("Post Title", "magazine-blocks")}>
					<Typography
						value={postTitleTypography}
						onChange={(val) =>
							setAttributes({ postTitleTypography: val })
						}
						resetAttributeKey="postTitleTypography"
					/>
					<PopoverDrawer
						label={__("Text Color", "magazine-blocks")}
						trigger={(props) => (
							<PopoverDrawer.Trigger {...props}>
								<ZStack
									items={[
										{
											color: postTitleColor,
											id: "postTitleColor",
										},
										{
											color: postTitleHoverColor,
											id: "postTitleHoverColor",
										},
									]}
								/>
							</PopoverDrawer.Trigger>
						)}
						closeOnFocusOutside
					>
						<Tabs position="relative">
							<TabList>
								<Tab>{__("Normal", "magazine-blocks")}</Tab>
								<Tab>{__("Hover", "magazine-blocks")}</Tab>
							</TabList>
							<TabPanels>
								<TabPanel>
									<Reset
										saved={postTitleColor}
										resetKey="postTitleColor"
										onReset={(v) => {
											setAttributes({
												postTitleColor: v,
											});
										}}
										buttonProps={{
											position: "absolute",
											top: "12px",
											right: "10px",
										}}
									/>
									<ColorPicker
										value={postTitleColor}
										onChange={(v) =>
											setAttributes({ postTitleColor: v })
										}
									/>
								</TabPanel>
								<TabPanel>
									<Reset
										saved={postTitleHoverColor}
										resetKey="postTitleHoverColor"
										onReset={(v) => {
											setAttributes({
												postTitleHoverColor: v,
											});
										}}
										buttonProps={{
											position: "absolute",
											top: "12px",
											right: "10px",
										}}
									/>
									<ColorPicker
										value={postTitleHoverColor}
										onChange={(v) =>
											setAttributes({
												postTitleHoverColor: v,
											})
										}
									/>
								</TabPanel>
							</TabPanels>
						</Tabs>
					</PopoverDrawer>
					<Dimensions
						value={postTitlePadding}
						responsive
						label={__("Padding", "magazine-blocks")}
						type="padding"
						defaultUnit="px"
						units={["px", "rem", "em", "%"]}
						onChange={(val) =>
							setAttributes({
								postTitlePadding: val,
							})
						}
						resetAttributeKey="postTitlePadding"
					/>
					<Dimensions
						value={postTitleMargin}
						responsive
						label={__("Margin", "magazine-blocks")}
						type="margin"
						defaultUnit="px"
						units={["px", "rem", "em", "%"]}
						onChange={(val) =>
							setAttributes({
								postTitleMargin: val,
							})
						}
						resetAttributeKey="postTitleMargin"
					/>
				</Panel>
				<Panel title={__("Header Meta", "magazine-blocks")}>
					<Tabs isFitted variant="unstyled">
						<TabList
							border="1px solid #E0E0E0"
							p="4px"
							borderRadius="2px"
						>
							{layout !== "layout-2" && (
								<Tab
									_selected={{
										color: "white",
										bg: "#7E36F4",
										borderRadius: "2px",
									}}
								>
									Post Box
								</Tab>
							)}
							<Tab
								_selected={{
									color: "white",
									bg: "#7E36F4",
									borderRadius: "2px",
								}}
							>
								Highlighted
							</Tab>
						</TabList>
						<TabPanels>
							{layout !== "layout-2" && (
								<TabPanel p="16px 0">
									<Box p="0 0 10px 0">
										<PopoverDrawer
											label={__(
												"Text Color",
												"magazine-blocks"
											)}
											trigger={(props) => (
												<PopoverDrawer.Trigger
													{...props}
												>
													<ZStack
														items={[
															{
																color: categoryColor,
																id: "categoryColor",
															},
															{
																color: categoryHoverColor,
																id: "categoryHoverColor",
															},
														]}
													/>
												</PopoverDrawer.Trigger>
											)}
											closeOnFocusOutside
										>
											<Tabs position="relative">
												<TabList>
													<Tab>
														{__(
															"Normal",
															"magazine-blocks"
														)}
													</Tab>
													<Tab>
														{__(
															"Hover",
															"magazine-blocks"
														)}
													</Tab>
												</TabList>
												<TabPanels>
													<TabPanel>
														<Reset
															saved={
																categoryColor
															}
															resetKey="categoryColor"
															onReset={(v) => {
																setAttributes({
																	categoryColor:
																		v,
																});
															}}
															buttonProps={{
																position:
																	"absolute",
																top: "12px",
																right: "10px",
															}}
														/>
														<ColorPicker
															value={
																categoryColor
															}
															onChange={(v) =>
																setAttributes({
																	categoryColor:
																		v,
																})
															}
														/>
													</TabPanel>
													<TabPanel>
														<Reset
															saved={
																categoryHoverColor
															}
															resetKey="categoryHoverColor"
															onReset={(v) => {
																setAttributes({
																	categoryHoverColor:
																		v,
																});
															}}
															buttonProps={{
																position:
																	"absolute",
																top: "12px",
																right: "10px",
															}}
														/>
														<ColorPicker
															value={
																categoryHoverColor
															}
															onChange={(v) =>
																setAttributes({
																	categoryHoverColor:
																		v,
																})
															}
														/>
													</TabPanel>
												</TabPanels>
											</Tabs>
										</PopoverDrawer>
									</Box>
									<Box p="0 0 10px 0">
										<Typography
											value={categoryTypography}
											onChange={(val) =>
												setAttributes({
													categoryTypography: val,
												})
											}
											resetAttributeKey="categoryTypography"
										/>
									</Box>
									<Box p="0 0 10px 0">
										<PopoverDrawer
											label={__(
												"Background",
												"magazine-blocks"
											)}
										>
											<Tabs position="relative">
												<TabList>
													<Tab>
														{__(
															"Normal",
															"magazine-blocks"
														)}
													</Tab>
													<Tab>
														{__(
															"Hover",
															"magazine-blocks"
														)}
													</Tab>
												</TabList>
												<TabPanels>
													<TabPanel>
														<Reset
															saved={
																categoryBackground
															}
															resetKey="categoryBackground"
															onReset={(v) => {
																setAttributes({
																	categoryBackground:
																		v,
																});
															}}
															buttonProps={{
																position:
																	"absolute",
																top: "12px",
																right: "10px",
															}}
														/>
														<Background
															value={
																categoryBackground
															}
															onChange={(v) =>
																setAttributes({
																	categoryBackground:
																		v,
																})
															}
														/>
													</TabPanel>
													<TabPanel>
														<Reset
															saved={
																categoryHoverBackground
															}
															resetKey="categoryHoverBackground"
															onReset={(v) => {
																setAttributes({
																	categoryHoverBackground:
																		v,
																});
															}}
															buttonProps={{
																position:
																	"absolute",
																top: "12px",
																right: "10px",
															}}
														/>
														<Background
															value={
																categoryHoverBackground
															}
															onChange={(v) =>
																setAttributes({
																	categoryHoverBackground:
																		v,
																})
															}
														/>
													</TabPanel>
												</TabPanels>
											</Tabs>
										</PopoverDrawer>
									</Box>
									<Dimensions
										value={categoryPadding}
										responsive
										label={__("Padding", "magazine-blocks")}
										type="padding"
										defaultUnit="px"
										units={["px", "rem", "em", "%"]}
										onChange={(val) =>
											setAttributes({
												categoryPadding: val,
											})
										}
										resetAttributeKey="categoryPadding"
									/>
									<Dimensions
										value={categoryMargin}
										responsive
										label={__("Margin", "magazine-blocks")}
										type="margin"
										defaultUnit="px"
										units={["px", "rem", "em", "%"]}
										onChange={(val) =>
											setAttributes({
												categoryMargin: val,
											})
										}
										resetAttributeKey="categoryMargin"
									/>
									<Box p="0 0 10px 0">
										<Toggle
											checked={enableCategoryBorder}
											onChange={() =>
												setAttributes({
													enableCategoryBorder:
														!enableCategoryBorder,
												})
											}
											label={__(
												"Border",
												"magazine-blocks"
											)}
										/>
									</Box>
									{enableCategoryBorder && (
										<Tabs isFitted variant="unstyled">
											<TabList
												border="1px solid #E0E0E0"
												p="4px"
												borderRadius="2px"
											>
												<Tab
													_selected={{
														color: "white",
														bg: "#7E36F4",
														borderRadius: "2px",
													}}
												>
													Normal
												</Tab>
												<Tab
													_selected={{
														color: "white",
														bg: "#7E36F4",
														borderRadius: "2px",
													}}
												>
													Hover
												</Tab>
											</TabList>
											<TabPanels>
												<TabPanel p="16px 0">
													<Border
														value={categoryBorder}
														onChange={(v) => {
															setAttributes({
																categoryBorder:
																	v,
															});
														}}
														resetAttributeKey="categoryBorder"
													/>
													<BoxShadow
														resetAttributeKey="categoryBoxShadow"
														value={
															categoryBoxShadow
														}
														onChange={(val) =>
															setAttributes({
																categoryBoxShadow:
																	val,
															})
														}
													/>
												</TabPanel>
												<TabPanel p="16px 0">
													<Border
														value={
															categoryHoverBorder
														}
														onChange={(v) => {
															setAttributes({
																categoryHoverBorder:
																	v,
															});
														}}
														resetAttributeKey="categoryHoverBorder"
													/>
													<BoxShadow
														resetAttributeKey="categoryBoxShadowHover"
														value={
															categoryBoxShadowHover
														}
														onChange={(val) =>
															setAttributes({
																categoryBoxShadowHover:
																	val,
															})
														}
													/>
												</TabPanel>
											</TabPanels>
										</Tabs>
									)}
								</TabPanel>
							)}
							<TabPanel p="16px 0">
								<Box p="0 0 10px 0">
									<PopoverDrawer
										label={__(
											"Text Color",
											"magazine-blocks"
										)}
										trigger={(props) => (
											<PopoverDrawer.Trigger {...props}>
												<ZStack
													items={[
														{
															color: highlightedCategoryColor,
															id: "highlightedCategoryColor",
														},
														{
															color: highlightedCategoryHoverColor,
															id: "highlightedCategoryHoverColor",
														},
													]}
												/>
											</PopoverDrawer.Trigger>
										)}
										closeOnFocusOutside
									>
										<Tabs position="relative">
											<TabList>
												<Tab>
													{__(
														"Normal",
														"magazine-blocks"
													)}
												</Tab>
												<Tab>
													{__(
														"Hover",
														"magazine-blocks"
													)}
												</Tab>
											</TabList>
											<TabPanels>
												<TabPanel>
													<Reset
														saved={
															highlightedCategoryColor
														}
														resetKey="highlightedCategoryColor"
														onReset={(v) => {
															setAttributes({
																highlightedCategoryColor:
																	v,
															});
														}}
														buttonProps={{
															position:
																"absolute",
															top: "12px",
															right: "10px",
														}}
													/>
													<ColorPicker
														value={
															highlightedCategoryColor
														}
														onChange={(v) =>
															setAttributes({
																highlightedCategoryColor:
																	v,
															})
														}
													/>
												</TabPanel>
												<TabPanel>
													<Reset
														saved={
															highlightedCategoryHoverColor
														}
														resetKey="highlightedCategoryHoverColor"
														onReset={(v) => {
															setAttributes({
																highlightedCategoryHoverColor:
																	v,
															});
														}}
														buttonProps={{
															position:
																"absolute",
															top: "12px",
															right: "10px",
														}}
													/>
													<ColorPicker
														value={
															highlightedCategoryHoverColor
														}
														onChange={(v) =>
															setAttributes({
																highlightedCategoryHoverColor:
																	v,
															})
														}
													/>
												</TabPanel>
											</TabPanels>
										</Tabs>
									</PopoverDrawer>
								</Box>
								<Box p="0 0 10px 0">
									<Typography
										value={highlightedCategoryTypography}
										onChange={(val) =>
											setAttributes({
												highlightedCategoryTypography:
													val,
											})
										}
										resetAttributeKey="highlightedCategoryTypography"
									/>
								</Box>
								<Box p="0 0 10px 0">
									<PopoverDrawer
										label={__(
											"Background",
											"magazine-blocks"
										)}
									>
										<Tabs position="relative">
											<TabList>
												<Tab>
													{__(
														"Normal",
														"magazine-blocks"
													)}
												</Tab>
												<Tab>
													{__(
														"Hover",
														"magazine-blocks"
													)}
												</Tab>
											</TabList>
											<TabPanels>
												<TabPanel>
													<Reset
														saved={
															highlightedCategoryBackground
														}
														resetKey="highlightedCategoryBackground"
														onReset={(v) => {
															setAttributes({
																highlightedCategoryBackground:
																	v,
															});
														}}
														buttonProps={{
															position:
																"absolute",
															top: "12px",
															right: "10px",
														}}
													/>
													<Background
														value={
															highlightedCategoryBackground
														}
														onChange={(v) =>
															setAttributes({
																highlightedCategoryBackground:
																	v,
															})
														}
													/>
												</TabPanel>
												<TabPanel>
													<Reset
														saved={
															highlightedCategoryHoverBackground
														}
														resetKey="highlightedCategoryHoverBackground"
														onReset={(v) => {
															setAttributes({
																highlightedCategoryHoverBackground:
																	v,
															});
														}}
														buttonProps={{
															position:
																"absolute",
															top: "12px",
															right: "10px",
														}}
													/>
													<Background
														value={
															highlightedCategoryHoverBackground
														}
														onChange={(v) =>
															setAttributes({
																highlightedCategoryHoverBackground:
																	v,
															})
														}
													/>
												</TabPanel>
											</TabPanels>
										</Tabs>
									</PopoverDrawer>
								</Box>
								<Dimensions
									value={highlightedCategoryPadding}
									responsive
									label={__("Padding", "magazine-blocks")}
									type="padding"
									defaultUnit="px"
									units={["px", "rem", "em", "%"]}
									onChange={(val) =>
										setAttributes({
											highlightedCategoryPadding: val,
										})
									}
									resetAttributeKey="highlightedCategoryPadding"
								/>
								<Dimensions
									value={highlightedCategoryMargin}
									responsive
									label={__("Margin", "magazine-blocks")}
									type="margin"
									defaultUnit="px"
									units={["px", "rem", "em", "%"]}
									onChange={(val) =>
										setAttributes({
											highlightedCategoryMargin: val,
										})
									}
								/>
								<Box p="0 0 10px 0">
									<Toggle
										checked={
											enableHighlightedCategoryBorder
										}
										onChange={() =>
											setAttributes({
												enableHighlightedCategoryBorder:
													!enableHighlightedCategoryBorder,
											})
										}
										label={__("Border", "magazine-blocks")}
									/>
								</Box>
								{enableHighlightedCategoryBorder && (
									<Tabs isFitted variant="unstyled">
										<TabList
											border="1px solid #E0E0E0"
											p="4px"
											borderRadius="2px"
										>
											<Tab
												_selected={{
													color: "white",
													bg: "#7E36F4",
													borderRadius: "2px",
												}}
											>
												Normal
											</Tab>
											<Tab
												_selected={{
													color: "white",
													bg: "#7E36F4",
													borderRadius: "2px",
												}}
											>
												Hover
											</Tab>
										</TabList>
										<TabPanels>
											<TabPanel p="16px 0">
												<Border
													value={
														highlightedCategoryBorder
													}
													onChange={(v) => {
														setAttributes({
															highlightedCategoryBorder:
																v,
														});
													}}
													resetAttributeKey="highlightedCategoryBorder"
												/>
												<BoxShadow
													resetAttributeKey="highlightedCategoryBoxShadow"
													value={
														highlightedCategoryBoxShadow
													}
													onChange={(val) =>
														setAttributes({
															highlightedCategoryBoxShadow:
																val,
														})
													}
												/>
											</TabPanel>
											<TabPanel p="16px 0">
												<Border
													value={
														highlightedCategoryHoverBorder
													}
													onChange={(v) => {
														setAttributes({
															highlightedCategoryHoverBorder:
																v,
														});
													}}
													resetAttributeKey="highlightedCategoryHoverBorder"
												/>
												<BoxShadow
													resetAttributeKey="highlightedCategoryBoxShadowHover"
													value={
														highlightedCategoryBoxShadowHover
													}
													onChange={(val) =>
														setAttributes({
															highlightedCategoryBoxShadowHover:
																val,
														})
													}
												/>
											</TabPanel>
										</TabPanels>
									</Tabs>
								)}
							</TabPanel>
						</TabPanels>
					</Tabs>
				</Panel>
				<Panel title={__("Meta", "magazine-blocks")}>
					<Tabs isFitted variant="unstyled">
						<TabList
							border="1px solid #E0E0E0"
							p="4px"
							borderRadius="2px"
						>
							<Tab
								_selected={{
									color: "white",
									bg: "#7E36F4",
									borderRadius: "2px",
								}}
							>
								Post Box
							</Tab>
							<Tab
								_selected={{
									color: "white",
									bg: "#7E36F4",
									borderRadius: "2px",
								}}
							>
								Highlighted
							</Tab>
						</TabList>
						<TabPanels>
							<TabPanel p="16px 0">
								<Box p="0 0 10px 0">
									<PopoverDrawer
										label={__(
											"Icon Color",
											"magazine-blocks"
										)}
										trigger={(props) => (
											<PopoverDrawer.Trigger {...props}>
												<ZStack
													items={[
														{
															color: metaIconColor,
															id: "metaIconColor",
														},
													]}
												/>
											</PopoverDrawer.Trigger>
										)}
										closeOnFocusOutside
									>
										<Tabs position="relative">
											<TabList>
												<Tab>
													{__(
														"Normal",
														"magazine-blocks"
													)}
												</Tab>
											</TabList>
											<TabPanels>
												<TabPanel>
													<Reset
														saved={metaIconColor}
														resetKey="metaIconColor"
														onReset={(v) => {
															setAttributes({
																metaIconColor:
																	v,
															});
														}}
														buttonProps={{
															position:
																"absolute",
															top: "12px",
															right: "10px",
														}}
													/>
													<ColorPicker
														value={metaIconColor}
														onChange={(v) =>
															setAttributes({
																metaIconColor:
																	v,
															})
														}
													/>
												</TabPanel>
											</TabPanels>
										</Tabs>
									</PopoverDrawer>
								</Box>

								<Box p="0 0 10px 0">
									<PopoverDrawer
										label={__(
											"Link Color",
											"magazine-blocks"
										)}
										trigger={(props) => (
											<PopoverDrawer.Trigger {...props}>
												<ZStack
													items={[
														{
															color: metaLinkColor,
															id: "color",
														},
														{
															color: metaLinkHoverColor,
															id: "hoverColor",
														},
													]}
												/>
											</PopoverDrawer.Trigger>
										)}
										closeOnFocusOutside
									>
										<Tabs position="relative">
											<TabList>
												<Tab>
													{__(
														"Normal",
														"magazine-blocks"
													)}
												</Tab>
												<Tab>
													{__(
														"Hover",
														"magazine-blocks"
													)}
												</Tab>
											</TabList>
											<TabPanels>
												<TabPanel>
													<Reset
														saved={metaLinkColor}
														resetKey="metaLinkColor"
														onReset={(v) => {
															setAttributes({
																metaLinkColor:
																	v,
															});
														}}
														buttonProps={{
															position:
																"absolute",
															top: "12px",
															right: "10px",
														}}
													/>
													<ColorPicker
														value={metaLinkColor}
														onChange={(v) =>
															setAttributes({
																metaLinkColor:
																	v,
															})
														}
													/>
												</TabPanel>
												<TabPanel>
													<Reset
														saved={
															metaLinkHoverColor
														}
														resetKey="metaLinkHoverColor"
														onReset={(v) => {
															setAttributes({
																metaLinkHoverColor:
																	v,
															});
														}}
														buttonProps={{
															position:
																"absolute",
															top: "12px",
															right: "10px",
														}}
													/>
													<ColorPicker
														value={
															metaLinkHoverColor
														}
														onChange={(v) =>
															setAttributes({
																metaLinkHoverColor:
																	v,
															})
														}
													/>
												</TabPanel>
											</TabPanels>
										</Tabs>
									</PopoverDrawer>
								</Box>
								<Box p="0 0 10px 0">
									<PopoverDrawer
										label={__(
											"Separator Color",
											"magazine-blocks"
										)}
										trigger={(props) => (
											<PopoverDrawer.Trigger {...props}>
												<ZStack
													items={[
														{
															color: metaSeparatorColor,
															id: "metaSeparatorColor",
														},
													]}
												/>
											</PopoverDrawer.Trigger>
										)}
										closeOnFocusOutside
									>
										<Tabs position="relative">
											<TabList>
												<Tab>
													{__(
														"Normal",
														"magazine-blocks"
													)}
												</Tab>
											</TabList>
											<TabPanels>
												<TabPanel>
													<Reset
														saved={
															metaSeparatorColor
														}
														resetKey="metaSeparatorColor"
														onReset={(v) => {
															setAttributes({
																metaSeparatorColor:
																	v,
															});
														}}
														buttonProps={{
															position:
																"absolute",
															top: "12px",
															right: "10px",
														}}
													/>
													<ColorPicker
														value={
															metaSeparatorColor
														}
														onChange={(v) =>
															setAttributes({
																metaSeparatorColor:
																	v,
															})
														}
													/>
												</TabPanel>
											</TabPanels>
										</Tabs>
									</PopoverDrawer>
								</Box>
								<Box p="0 0 10px 0">
									<Typography
										value={metaTypography}
										onChange={(val) =>
											setAttributes({
												metaTypography: val,
											})
										}
										resetAttributeKey="metaTypography"
									/>
								</Box>
							</TabPanel>
							<TabPanel p="16px 0">
								<Box p="0 0 10px 0">
									<PopoverDrawer
										label={__(
											"Icon Color",
											"magazine-blocks"
										)}
										trigger={(props) => (
											<PopoverDrawer.Trigger {...props}>
												<ZStack
													items={[
														{
															color: highlightMetaIconColor,
															id: "highlightMetaIconColor",
														},
													]}
												/>
											</PopoverDrawer.Trigger>
										)}
										closeOnFocusOutside
									>
										<Tabs position="relative">
											<TabList>
												<Tab>
													{__(
														"Normal",
														"magazine-blocks"
													)}
												</Tab>
											</TabList>
											<TabPanels>
												<TabPanel>
													<Reset
														saved={
															highlightMetaIconColor
														}
														resetKey="highlightMetaIconColor"
														onReset={(v) => {
															setAttributes({
																highlightMetaIconColor:
																	v,
															});
														}}
														buttonProps={{
															position:
																"absolute",
															top: "12px",
															right: "10px",
														}}
													/>
													<ColorPicker
														value={
															highlightMetaIconColor
														}
														onChange={(v) =>
															setAttributes({
																highlightMetaIconColor:
																	v,
															})
														}
													/>
												</TabPanel>
											</TabPanels>
										</Tabs>
									</PopoverDrawer>
								</Box>
								<Box p="0 0 10px 0">
									<PopoverDrawer
										label={__(
											"Link Color",
											"magazine-blocks"
										)}
										trigger={(props) => (
											<PopoverDrawer.Trigger {...props}>
												<ZStack
													items={[
														{
															color: highlightMetaLinkColor,
															id: "color",
														},
														{
															color: highlightMetaLinkHoverColor,
															id: "hoverColor",
														},
													]}
												/>
											</PopoverDrawer.Trigger>
										)}
										closeOnFocusOutside
									>
										<Tabs position="relative">
											<TabList>
												<Tab>
													{__(
														"Normal",
														"magazine-blocks"
													)}
												</Tab>
												<Tab>
													{__(
														"Hover",
														"magazine-blocks"
													)}
												</Tab>
											</TabList>
											<TabPanels>
												<TabPanel>
													<Reset
														saved={
															highlightMetaLinkColor
														}
														resetKey="highlightMetaLinkColor"
														onReset={(v) => {
															setAttributes({
																highlightMetaLinkColor:
																	v,
															});
														}}
														buttonProps={{
															position:
																"absolute",
															top: "12px",
															right: "10px",
														}}
													/>
													<ColorPicker
														value={
															highlightMetaLinkColor
														}
														onChange={(v) =>
															setAttributes({
																highlightMetaLinkColor:
																	v,
															})
														}
													/>
												</TabPanel>
												<TabPanel>
													<Reset
														saved={
															highlightMetaLinkHoverColor
														}
														resetKey="highlightMetaLinkHoverColor"
														onReset={(v) => {
															setAttributes({
																highlightMetaLinkHoverColor:
																	v,
															});
														}}
														buttonProps={{
															position:
																"absolute",
															top: "12px",
															right: "10px",
														}}
													/>
													<ColorPicker
														value={
															highlightMetaLinkHoverColor
														}
														onChange={(v) =>
															setAttributes({
																highlightMetaLinkHoverColor:
																	v,
															})
														}
													/>
												</TabPanel>
											</TabPanels>
										</Tabs>
									</PopoverDrawer>
								</Box>
								<Box p="0 0 10px 0">
									<PopoverDrawer
										label={__(
											"Separator Color",
											"magazine-blocks"
										)}
										trigger={(props) => (
											<PopoverDrawer.Trigger {...props}>
												<ZStack
													items={[
														{
															color: highlightMetaSeparatorColor,
															id: "highlightMetaSeparatorColor",
														},
													]}
												/>
											</PopoverDrawer.Trigger>
										)}
										closeOnFocusOutside
									>
										<Tabs position="relative">
											<TabList>
												<Tab>
													{__(
														"Normal",
														"magazine-blocks"
													)}
												</Tab>
											</TabList>
											<TabPanels>
												<TabPanel>
													<Reset
														saved={
															highlightMetaSeparatorColor
														}
														resetKey="highlightMetaSeparatorColor"
														onReset={(v) => {
															setAttributes({
																highlightMetaSeparatorColor:
																	v,
															});
														}}
														buttonProps={{
															position:
																"absolute",
															top: "12px",
															right: "10px",
														}}
													/>
													<ColorPicker
														value={
															highlightMetaSeparatorColor
														}
														onChange={(v) =>
															setAttributes({
																highlightMetaSeparatorColor:
																	v,
															})
														}
													/>
												</TabPanel>
											</TabPanels>
										</Tabs>
									</PopoverDrawer>
								</Box>
								<Box p="0 0 10px 0">
									<Typography
										value={highlightMetaTypography}
										onChange={(val) =>
											setAttributes({
												highlightMetaTypography: val,
											})
										}
										resetAttributeKey="highlightMetaTypography"
									/>
								</Box>
							</TabPanel>
						</TabPanels>
					</Tabs>
				</Panel>
				{enableExcerpt && (
					<Panel title={__("Excerpt", "magazine-blocks")}>
						<PopoverDrawer
							label={__("Text Color", "magazine-blocks")}
							trigger={(props) => (
								<PopoverDrawer.Trigger {...props}>
									<ZStack
										items={[
											{
												color: excerptColor,
												id: "color",
											},
										]}
									/>
								</PopoverDrawer.Trigger>
							)}
							closeOnFocusOutside
						>
							<Tabs position="relative">
								<TabList>
									<Tab>{__("Normal", "magazine-blocks")}</Tab>
								</TabList>
								<TabPanels>
									<TabPanel>
										<Reset
											saved={excerptColor}
											resetKey="excerptColor"
											onReset={(v) => {
												setAttributes({
													excerptColor: v,
												});
											}}
											buttonProps={{
												position: "absolute",
												top: "12px",
												right: "10px",
											}}
										/>
										<ColorPicker
											value={excerptColor}
											onChange={(v) =>
												setAttributes({
													excerptColor: v,
												})
											}
										/>
									</TabPanel>
								</TabPanels>
							</Tabs>
						</PopoverDrawer>
						<Dimensions
							value={excerptMargin}
							responsive
							label={__("Margin", "magazine-blocks")}
							type="margin"
							defaultUnit="px"
							units={["px", "rem", "em", "%"]}
							onChange={(val) =>
								setAttributes({ excerptMargin: val })
							}
							resetAttributeKey="excerptMargin"
						/>
						<Typography
							value={excerptTypography}
							onChange={(val) =>
								setAttributes({
									excerptTypography: val,
								})
							}
							resetAttributeKey="excerptTypography"
						/>
					</Panel>
				)}

				{enableReadMore && (
					<Panel title={__("Read More", "magazine-blocks")}>
						<PopoverDrawer
							label={__("Text Color", "magazine-blocks")}
							trigger={(props) => (
								<PopoverDrawer.Trigger {...props}>
									<ZStack
										items={[
											{
												color: readMoreColor,
												id: "readMoreColor",
											},
											{
												color: readMorewHoverColor,
												id: "readMorewHoverColor",
											},
										]}
									/>
								</PopoverDrawer.Trigger>
							)}
							closeOnFocusOutside
						>
							<Tabs position="relative">
								<TabList>
									<Tab>{__("Normal", "magazine-blocks")}</Tab>
									<Tab>{__("Hover", "magazine-blocks")}</Tab>
								</TabList>
								<TabPanels>
									<TabPanel>
										<Reset
											saved={readMoreColor}
											resetKey="readMoreColor"
											onReset={(v) => {
												setAttributes({
													readMoreColor: v,
												});
											}}
											buttonProps={{
												position: "absolute",
												top: "12px",
												right: "10px",
											}}
										/>
										<ColorPicker
											value={readMoreColor}
											onChange={(v) =>
												setAttributes({
													readMoreColor: v,
												})
											}
										/>
									</TabPanel>
									<TabPanel>
										<Reset
											saved={readMorewHoverColor}
											resetKey="readMorewHoverColor"
											onReset={(v) => {
												setAttributes({
													readMorewHoverColor: v,
												});
											}}
											buttonProps={{
												position: "absolute",
												top: "12px",
												right: "10px",
											}}
										/>
										<ColorPicker
											value={readMorewHoverColor}
											onChange={(v) =>
												setAttributes({
													readMorewHoverColor: v,
												})
											}
										/>
									</TabPanel>
								</TabPanels>
							</Tabs>
						</PopoverDrawer>
						<Typography
							value={readMoreTypography}
							onChange={(val) =>
								setAttributes({
									readMoreTypography: val,
								})
							}
							resetAttributeKey="readMoreTypography"
						/>
						<PopoverDrawer
							label={__("Background", "magazine-blocks")}
						>
							<Tabs position="relative">
								<TabList>
									<Tab>{__("Normal", "magazine-blocks")}</Tab>
									<Tab>{__("Hover", "magazine-blocks")}</Tab>
								</TabList>
								<TabPanels>
									<TabPanel>
										<Reset
											saved={readMoreBackground}
											resetKey="readMoreBackground"
											onReset={(v) => {
												setAttributes({
													readMoreBackground: v,
												});
											}}
											buttonProps={{
												position: "absolute",
												top: "12px",
												right: "10px",
											}}
										/>
										<Background
											value={readMoreBackground}
											onChange={(v) =>
												setAttributes({
													readMoreBackground: v,
												})
											}
										/>
									</TabPanel>
									<TabPanel>
										<Reset
											saved={readMoreHoverBackground}
											resetKey="readMoreHoverBackground"
											onReset={(v) => {
												setAttributes({
													readMoreHoverBackground: v,
												});
											}}
											buttonProps={{
												position: "absolute",
												top: "12px",
												right: "10px",
											}}
										/>
										<Background
											value={readMoreHoverBackground}
											onChange={(v) =>
												setAttributes({
													readMoreHoverBackground: v,
												})
											}
										/>
									</TabPanel>
								</TabPanels>
							</Tabs>
						</PopoverDrawer>
						<Dimensions
							value={readMorePadding}
							responsive
							label={__("Padding", "magazine-blocks")}
							type="margin"
							defaultUnit="px"
							units={["px", "rem", "em", "%"]}
							onChange={(val) =>
								setAttributes({ readMorePadding: val })
							}
							resetAttributeKey="readMorePadding"
						/>
						<Slider
							onChange={(val: any) =>
								setAttributes({ readMoreSpacing: val })
							}
							label={__("Top Spacing", "magazine-blocks")}
							units={["px", "em", "%"]}
							responsive={true}
							min={0}
							max={100}
							value={readMoreSpacing}
						/>
						{enableReadMoreIcon && (
							<>
								<Slider
									onChange={(val: any) =>
										setAttributes({
											readMoreIconSpacing: val,
										})
									}
									label={__(
										"Icon Spacing",
										"magazine-blocks"
									)}
									units={["px", "em", "%"]}
									responsive={true}
									min={0}
									max={100}
									value={readMoreIconSpacing}
								/>
								<Slider
									label={__("Icon Size", "magazine-blocks")}
									min={0}
									max={50}
									value={readMoreIconSize}
									onChange={(val: any) =>
										setAttributes({ readMoreIconSize: val })
									}
									responsive
									units={["px", "em", "%"]}
								/>
							</>
						)}
						<Toggle
							checked={enableReadMoreBorder}
							onChange={() =>
								setAttributes({
									enableReadMoreBorder: !enableReadMoreBorder,
								})
							}
							label={__("Border", "magazine-blocks")}
						/>
						{enableReadMoreBorder && (
							<Tabs isFitted variant="unstyled">
								<TabList
									border="1px solid #E0E0E0"
									p="4px"
									borderRadius="2px"
								>
									<Tab
										_selected={{
											color: "white",
											bg: "#7E36F4",
											borderRadius: "2px",
										}}
									>
										Normal
									</Tab>
									<Tab
										_selected={{
											color: "white",
											bg: "#7E36F4",
											borderRadius: "2px",
										}}
									>
										Hover
									</Tab>
								</TabList>
								<TabPanels>
									<TabPanel p="16px 0">
										<Border
											value={readMoreBorder}
											onChange={(v) => {
												setAttributes({
													readMoreBorder: v,
												});
											}}
											resetAttributeKey="readMoreBorder"
										/>
										<BoxShadow
											resetAttributeKey="readMoreBoxShadow"
											value={readMoreBoxShadow}
											onChange={(val) =>
												setAttributes({
													readMoreBoxShadow: val,
												})
											}
										/>
									</TabPanel>
									<TabPanel p="16px 0">
										<Border
											value={readMoreHoverBorder}
											onChange={(v) => {
												setAttributes({
													readMoreHoverBorder: v,
												});
											}}
											resetAttributeKey="readMoreHoverBorder"
										/>
										<BoxShadow
											resetAttributeKey="readMoreBoxShadowHover"
											value={readMoreBoxShadowHover}
											onChange={(val) =>
												setAttributes({
													readMoreBoxShadowHover: val,
												})
											}
										/>
									</TabPanel>
								</TabPanels>
							</Tabs>
						)}
					</Panel>
				)}
				{enableViewMore && (
					<Panel title={__("View All", "magazine-blocks")}>
						<PopoverDrawer
							label={__("Text Color", "magazine-blocks")}
							trigger={(props) => (
								<PopoverDrawer.Trigger {...props}>
									<ZStack
										items={[
											{
												color: viewMoreColor,
												id: "viewMoreColor",
											},
											{
												color: viewMoreHoverColor,
												id: "viewMoreHoverColor",
											},
										]}
									/>
								</PopoverDrawer.Trigger>
							)}
							closeOnFocusOutside
						>
							<Tabs position="relative">
								<TabList>
									<Tab>{__("Normal", "magazine-blocks")}</Tab>
									<Tab>{__("Hover", "magazine-blocks")}</Tab>
								</TabList>
								<TabPanels>
									<TabPanel>
										<Reset
											saved={viewMoreColor}
											resetKey="viewMoreColor"
											onReset={(v) => {
												setAttributes({
													viewMoreColor: v,
												});
											}}
											buttonProps={{
												position: "absolute",
												top: "12px",
												right: "10px",
											}}
										/>
										<ColorPicker
											value={viewMoreColor}
											onChange={(v) =>
												setAttributes({
													viewMoreColor: v,
												})
											}
										/>
									</TabPanel>
									<TabPanel>
										<Reset
											saved={viewMoreHoverColor}
											resetKey="viewMoreHoverColor"
											onReset={(v) => {
												setAttributes({
													viewMoreHoverColor: v,
												});
											}}
											buttonProps={{
												position: "absolute",
												top: "12px",
												right: "10px",
											}}
										/>
										<ColorPicker
											value={viewMoreHoverColor}
											onChange={(v) =>
												setAttributes({
													viewMoreHoverColor: v,
												})
											}
										/>
									</TabPanel>
								</TabPanels>
							</Tabs>
						</PopoverDrawer>
						<Typography
							value={viewAllTypography}
							onChange={(val) =>
								setAttributes({
									viewAllTypography: val,
								})
							}
							resetAttributeKey="viewAllTypography"
						/>
						<PopoverDrawer
							label={__("Background", "magazine-blocks")}
						>
							<Tabs position="relative">
								<TabList>
									<Tab>{__("Normal", "magazine-blocks")}</Tab>
									<Tab>{__("Hover", "magazine-blocks")}</Tab>
								</TabList>
								<TabPanels>
									<TabPanel>
										<Reset
											saved={viewMoreBackground}
											resetKey="viewMoreBackground"
											onReset={(v) => {
												setAttributes({
													viewMoreBackground: v,
												});
											}}
											buttonProps={{
												position: "absolute",
												top: "12px",
												right: "10px",
											}}
										/>
										<Background
											value={viewMoreBackground}
											onChange={(v) =>
												setAttributes({
													viewMoreBackground: v,
												})
											}
										/>
									</TabPanel>
									<TabPanel>
										<Reset
											saved={viewMoreHoverBackground}
											resetKey="viewMoreHoverBackground"
											onReset={(v) => {
												setAttributes({
													viewMoreHoverBackground: v,
												});
											}}
											buttonProps={{
												position: "absolute",
												top: "12px",
												right: "10px",
											}}
										/>
										<Background
											value={viewMoreHoverBackground}
											onChange={(v) =>
												setAttributes({
													viewMoreHoverBackground: v,
												})
											}
										/>
									</TabPanel>
								</TabPanels>
							</Tabs>
						</PopoverDrawer>
						<Dimensions
							value={viewMorePadding}
							responsive
							label={__("Padding", "magazine-blocks")}
							type="margin"
							defaultUnit="px"
							units={["px", "rem", "em", "%"]}
							onChange={(val) =>
								setAttributes({ viewMorePadding: val })
							}
							resetAttributeKey="viewMorePadding"
						/>
						{enableViewMoreIcon && (
							<>
								<Slider
									onChange={(val: any) =>
										setAttributes({ viewMoreSpacing: val })
									}
									label={__(
										"Icon Spacing",
										"magazine-blocks"
									)}
									units={["px", "em", "%"]}
									responsive={true}
									min={0}
									max={100}
									value={viewMoreSpacing}
								/>
								<Slider
									label={__("Icon Size", "magazine-blocks")}
									min={0}
									max={50}
									value={iconSize}
									onChange={(val: any) =>
										setAttributes({ iconSize: val })
									}
									responsive
									units={["px", "em", "%"]}
								/>
							</>
						)}
						<Toggle
							checked={enableViewMoreBorder}
							onChange={() =>
								setAttributes({
									enableViewMoreBorder: !enableViewMoreBorder,
								})
							}
							label={__("Border", "magazine-blocks")}
						/>
						{enableViewMoreBorder && (
							<Tabs isFitted variant="unstyled">
								<TabList
									border="1px solid #E0E0E0"
									p="4px"
									borderRadius="2px"
								>
									<Tab
										_selected={{
											color: "white",
											bg: "#7E36F4",
											borderRadius: "2px",
										}}
									>
										Normal
									</Tab>
									<Tab
										_selected={{
											color: "white",
											bg: "#7E36F4",
											borderRadius: "2px",
										}}
									>
										Hover
									</Tab>
								</TabList>
								<TabPanels>
									<TabPanel p="16px 0">
										<Border
											value={viewMoreBorder}
											onChange={(v) => {
												setAttributes({
													viewMoreBorder: v,
												});
											}}
											resetAttributeKey="viewMoreBorder"
										/>
										<BoxShadow
											resetAttributeKey="viewMoreBoxShadow"
											value={viewMoreBoxShadow}
											onChange={(val) =>
												setAttributes({
													viewMoreBoxShadow: val,
												})
											}
										/>
									</TabPanel>
									<TabPanel p="16px 0">
										<Border
											value={viewMoreHoverBorder}
											onChange={(v) => {
												setAttributes({
													viewMoreHoverBorder: v,
												});
											}}
											resetAttributeKey="viewMoreHoverBorder"
										/>
										<BoxShadow
											resetAttributeKey="viewMoreBoxShadowHover"
											value={viewMoreBoxShadowHover}
											onChange={(val) =>
												setAttributes({
													viewMoreBoxShadowHover: val,
												})
											}
										/>
									</TabPanel>
								</TabPanels>
							</Tabs>
						)}
					</Panel>
				)}

				{enablePagination && (
					<Panel title={__("Pagination", "magazine-blocks")}>
						<PopoverDrawer
							label={__("Text Color", "magazine-blocks")}
							trigger={(props) => (
								<PopoverDrawer.Trigger {...props}>
									<ZStack
										items={[
											{
												color: paginationColor,
												id: "arrowColor",
											},
											{
												color: paginationHoverColor,
												id: "arrowHoverColor",
											},
										]}
									/>
								</PopoverDrawer.Trigger>
							)}
							closeOnFocusOutside
						>
							<Tabs position="relative">
								<TabList>
									<Tab>{__("Normal", "magazine-blocks")}</Tab>
									<Tab>{__("Hover", "magazine-blocks")}</Tab>
								</TabList>
								<TabPanels>
									<TabPanel>
										<Reset
											saved={paginationColor}
											resetKey="paginationColor"
											onReset={(v) => {
												setAttributes({
													paginationColor: v,
												});
											}}
											buttonProps={{
												position: "absolute",
												top: "12px",
												right: "10px",
											}}
										/>
										<ColorPicker
											value={paginationColor}
											onChange={(v) =>
												setAttributes({
													paginationColor: v,
												})
											}
										/>
									</TabPanel>
									<TabPanel>
										<Reset
											saved={paginationHoverColor}
											resetKey="paginationHoverColor"
											onReset={(v) => {
												setAttributes({
													paginationHoverColor: v,
												});
											}}
											buttonProps={{
												position: "absolute",
												top: "12px",
												right: "10px",
											}}
										/>
										<ColorPicker
											value={paginationHoverColor}
											onChange={(v) =>
												setAttributes({
													paginationHoverColor: v,
												})
											}
										/>
									</TabPanel>
								</TabPanels>
							</Tabs>
						</PopoverDrawer>
						<PopoverDrawer
							label={__("Background", "magazine-blocks")}
						>
							<Tabs position="relative">
								<TabList>
									<Tab>{__("Normal", "magazine-blocks")}</Tab>
									<Tab>{__("Hover", "magazine-blocks")}</Tab>
								</TabList>
								<TabPanels>
									<TabPanel>
										<Reset
											saved={paginationBackground}
											resetKey="paginationBackground"
											onReset={(v) => {
												setAttributes({
													paginationBackground: v,
												});
											}}
											buttonProps={{
												position: "absolute",
												top: "12px",
												right: "10px",
											}}
										/>
										<Background
											value={paginationBackground}
											onChange={(v) =>
												setAttributes({
													paginationBackground: v,
												})
											}
										/>
									</TabPanel>
									<TabPanel>
										<Reset
											saved={paginationHoverBackground}
											resetKey="paginationHoverBackground"
											onReset={(v) => {
												setAttributes({
													paginationHoverBackground:
														v,
												});
											}}
											buttonProps={{
												position: "absolute",
												top: "12px",
												right: "10px",
											}}
										/>
										<Background
											value={paginationHoverBackground}
											onChange={(v) =>
												setAttributes({
													paginationHoverBackground:
														v,
												})
											}
										/>
									</TabPanel>
								</TabPanels>
							</Tabs>
						</PopoverDrawer>
						<Dimensions
							value={paginationPadding}
							responsive
							label={__("Padding", "magazine-blocks")}
							type="padding"
							defaultUnit="px"
							units={["px", "rem", "em", "%"]}
							onChange={(val) =>
								setAttributes({ paginationPadding: val })
							}
							resetAttributeKey="paginationPadding"
						/>
						<Toggle
							checked={!!paginationBorder?.border}
							onChange={() =>
								setAttributes({
									paginationBorder: {
										...paginationBorder,
										border: paginationBorder?.border
											? 0
											: 1,
									},
								})
							}
							label={__("Enable Border", "magazine-blocks")}
						/>

						{!!paginationBorder?.border && (
							<Tabs isFitted variant="unstyled">
								<TabList
									border="1px solid #E0E0E0"
									p="4px"
									borderRadius="2px"
								>
									<Tab
										_selected={{
											color: "white",
											bg: "#7E36F4",
											borderRadius: "2px",
										}}
									>
										Normal
									</Tab>
									<Tab
										_selected={{
											color: "white",
											bg: "#7E36F4",
											borderRadius: "2px",
										}}
									>
										Hover
									</Tab>
								</TabList>
								<TabPanels>
									<TabPanel p="16px 0">
										<Border
											value={paginationBorder}
											onChange={(v) => {
												setAttributes({
													paginationBorder: v,
												});
											}}
											resetAttributeKey="paginationBorder"
										/>
										<BoxShadow
											resetAttributeKey="paginationBoxShadow"
											value={paginationBoxShadow}
											onChange={(val) =>
												setAttributes({
													paginationBoxShadow: val,
												})
											}
										/>
									</TabPanel>
									<TabPanel p="16px 0">
										<Border
											value={paginationHoverBorder}
											onChange={(v) => {
												setAttributes({
													paginationHoverBorder: v,
												});
											}}
											resetAttributeKey="paginationHoverBorder"
										/>
										<BoxShadow
											resetAttributeKey="paginationBoxShadowHover"
											value={paginationBoxShadowHover}
											onChange={(val) =>
												setAttributes({
													paginationBoxShadowHover:
														val,
												})
											}
										/>
									</TabPanel>
								</TabPanels>
							</Tabs>
						)}
					</Panel>
				)}

				<Panel title={__("Post Card", "magazine-blocks")}>
					<PopoverDrawer label={__("Background", "magazine-blocks")}>
						<Tabs position="relative">
							<TabList>
								<Tab>{__("Normal", "magazine-blocks")}</Tab>
								<Tab>{__("Hover", "magazine-blocks")}</Tab>
							</TabList>
							<TabPanels>
								<TabPanel>
									<Reset
										saved={postCardBackground}
										resetKey="postCardBackground"
										onReset={(v) => {
											setAttributes({
												postCardBackground: v,
											});
										}}
										buttonProps={{
											position: "absolute",
											top: "12px",
											right: "10px",
										}}
									/>
									<Background
										value={postCardBackground}
										onChange={(v) =>
											setAttributes({
												postCardBackground: v,
											})
										}
									/>
								</TabPanel>
								<TabPanel>
									<Reset
										saved={postCardHoverBackground}
										resetKey="postCardHoverBackground"
										onReset={(v) => {
											setAttributes({
												postCardHoverBackground: v,
											});
										}}
										buttonProps={{
											position: "absolute",
											top: "12px",
											right: "10px",
										}}
									/>
									<Background
										value={postCardHoverBackground}
										onChange={(v) =>
											setAttributes({
												postCardHoverBackground: v,
											})
										}
									/>
								</TabPanel>
							</TabPanels>
						</Tabs>
					</PopoverDrawer>
					<Dimensions
						value={postCardPadding}
						responsive
						label={__("Padding", "magazine-blocks")}
						type="padding"
						defaultUnit="px"
						units={["px", "rem", "em", "%"]}
						onChange={(val) =>
							setAttributes({ postCardPadding: val })
						}
						resetAttributeKey="postCardPadding"
					/>
					<Toggle
						checked={!!postCardBorder?.border}
						onChange={() =>
							setAttributes({
								postCardBorder: {
									...postCardBorder,
									border: postCardBorder?.border ? 0 : 1,
								},
							})
						}
						label={__("Enable Border", "magazine-blocks")}
					/>

					{!!postCardBorder?.border && (
						<Tabs isFitted variant="unstyled">
							<TabList
								border="1px solid #E0E0E0"
								p="4px"
								borderRadius="2px"
							>
								<Tab
									_selected={{
										color: "white",
										bg: "#7E36F4",
										borderRadius: "2px",
									}}
								>
									Normal
								</Tab>
								<Tab
									_selected={{
										color: "white",
										bg: "#7E36F4",
										borderRadius: "2px",
									}}
								>
									Hover
								</Tab>
							</TabList>
							<TabPanels>
								<TabPanel p="16px 0">
									<Border
										value={postCardBorder}
										onChange={(v) => {
											setAttributes({
												postCardBorder: v,
											});
										}}
										resetAttributeKey="postCardBorder"
									/>
									<BoxShadow
										resetAttributeKey="postCardBoxShadow"
										value={postCardBoxShadow}
										onChange={(val) =>
											setAttributes({
												postCardBoxShadow: val,
											})
										}
									/>
								</TabPanel>
								<TabPanel p="16px 0">
									<Border
										value={postCardHoverBorder}
										onChange={(v) => {
											setAttributes({
												postCardHoverBorder: v,
											});
										}}
										resetAttributeKey="postCardHoverBorder"
									/>
									<BoxShadow
										resetAttributeKey="postCardBoxShadowHover"
										value={postCardBoxShadowHover}
										onChange={(val) =>
											setAttributes({
												postCardBoxShadowHover: val,
											})
										}
									/>
								</TabPanel>
							</TabPanels>
						</Tabs>
					)}
				</Panel>
			</StyleInspectorControls>
			<AdvancedInspectorControls>
				<AdvancedControls
					blockMargin={blockMargin}
					setAttributes={setAttributes}
					blockPadding={blockPadding}
				/>
				<ResponsiveControls
					{...{
						hideOnDesktop,
						hideOnTablet,
						hideOnMobile,
						setAttributes,
					}}
				/>
			</AdvancedInspectorControls>
		</>
	);
};

export default InspectorControls;
